import { Capacitor, CapacitorHttp } from '@capacitor/core';

export type KeycloakHttpResponse = {
	ok: boolean;
	status: number;
	json: () => Promise<unknown>;
};

/**
 * HTTP helper for Keycloak Account API calls.
 * Uses Capacitor native HTTP on device (no WebView CORS); `fetch` on web.
 */
export async function keycloakHttpRequest(
	url: string,
	init: {
		method: string;
		headers?: Record<string, string>;
		body?: string;
	},
): Promise<KeycloakHttpResponse> {
	if (Capacitor.isNativePlatform()) {
		let data: string | Record<string, unknown> | undefined;
		if (init.body !== undefined) {
			try {
				data = JSON.parse(init.body) as Record<string, unknown>;
			} catch {
				data = init.body;
			}
		}

		const response = await CapacitorHttp.request({
			url,
			method: init.method,
			headers: init.headers,
			data,
			responseType: 'json',
		});

		const status = response.status;
		const responseData = response.data;

		return {
			ok: status >= 200 && status < 300,
			status,
			json: async () => responseData,
		};
	}

	const response = await fetch(url, {
		method: init.method,
		headers: init.headers,
		body: init.body,
	});

	return {
		ok: response.ok,
		status: response.status,
		json: async () => response.json() as Promise<unknown>,
	};
}
